import { createTheme } from '@mui/material/styles';

const lightGreen = '#A8E055';
const darkGreen = '#0B894B';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      light: lightGreen,
      main: darkGreen,
      dark: darkGreen,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontSize: 16,
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default theme;
